import React, { useEffect, useRef, useCallback } from 'react';
import Dialog from '../../common/components/Dialog';

type StopRenewingDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onButtonClick: () => void;
};

const StopRenewingDialog = ({ isOpen, onClose, onButtonClick }: StopRenewingDialogProps) => {
  const dialogRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      if (dialogRef.current && !dialogRef.current.contains(event.target as Node)) {
        onClose();
      }
    },
    [onClose]
  );

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleClickOutside]);

  return (
    <Dialog isOpen={isOpen} onClose={onClose}>
      <div ref={dialogRef} className={`settings-modal modal modal--large`}>
        <div className="settings-modal__wrapper modal__wrapper">
          <div className="settings-modal__header modal__header">
            <h5 className="settings-modal__title archivo">
              {/* TODO: Translate */}
              Zrušení automatického obnovení
            </h5>

            <button className="close-button" onClick={onClose}></button>
          </div>
          <div className="settings-modal__content modal__content">
            {/* TODO: Translate */}
            Pokud zrušíte automatické obnovení, váš přístup k obsahu bude ukončen na konci aktuálního období.
          </div>
        </div>
        <div className="settings-modal__footer modal__footer" style={{ justifyContent: 'flex-end', gap: '1.6rem' }}>
          <button className="link link--medium" onClick={onButtonClick}>
            {/* TODO: Translate */}
            Zrušit automatické obnovení
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default StopRenewingDialog;
